"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listUsersUseCase = void 0;
const buildUsers_1 = require("@/useCases/useCaseUtilities/buildUsers");
const users_1 = require("@/services/users");
const users_2 = require("@/store/ducks/users");
function listUsersUseCase(queryParameters) {
    return async (dispatch) => {
        dispatch((0, users_2.getUsers)());
        try {
            const users = await (0, users_1.listAllUsers)(queryParameters);
            const parsedUsers = (0, buildUsers_1.buildUsers)(users);
            dispatch((0, users_2.getUsersSuccess)(parsedUsers));
        }
        catch (error) {
            dispatch((0, users_2.getUsersError)());
        }
    };
}
exports.listUsersUseCase = listUsersUseCase;
